// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hayah {
  font-size: 150px;
  display: block;
  width: 100%;
  margin-bottom: 30px;
  margin-top: 3vh;
  color: #ab8774;
  text-align: center;
  text-shadow: 1px 1px #dbb49f;
}

ion-list {
  --background: transparent;
  background: transparent;
}

ion-item {
  border-radius: 4px;
  border-bottom: 5px solid #d1a992;
  margin-bottom: 5px;
  padding-bottom: 2px;
}

ion-label {
  color: #ab8774 !important;
}

ion-input,
ion-textarea,
input::-webkit-input-placeholder {
  color: #dbb49f;
}

ion-input,
ion-textarea,
input {
  color: #866858;
}

.auth_start {
  text-align: center;
  margin-top: 5vh;
}
.auth_start button {
  min-width: 60%;
  width: -moz-fit-content;
  width: fit-content;
  padding: 20px;
  border: 1px solid #d2a892;
  border-bottom-width: 4px;
  background: none;
  border-radius: 4px;
  color: #a0755f;
  margin-top: 0px;
  margin-bottom: 10px;
  font-size: 12px;
  font-weight: bold;
  white-space: nowrap;
  text-transform: uppercase;
}
.auth_start button:hover,
.auth_start button:active {
  border-bottom-width: 6px;
}
.auth_start label {
  color: #ab8774;
}
.auth_start ion-list {
  margin: 25px;
}
.auth_start .form_floater {
  color: #8e8e8e;
}
.auth_start .filled {
  background: rgba(160, 117, 95, 0.7764705882);
  color: #fff1e5;
}

.start_auth {
  margin-top: 0vh;
}

.forgot_pass_txt {
  font-size: 12px;
}

.signup_txt {
  text-align: center;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  color: #b6917c;
}
.signup_txt b {
  display: inline-block;
  font-size: 21px;
  margin: 8px 0;
}

.inline_inputter {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.inline_inputter ion-icon {
  font-size: 21px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/login/login.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,cAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,4BAAA;AACJ;;AAEA;EACI,yBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,gCAAA;EACA,kBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;;;EAGI,cAAA;AACJ;;AAEA;;;EAGI,cAAA;AACJ;;AAEA;EACI,kBAAA;EACA,eAAA;AACJ;AACI;EACI,cAAA;EACA,uBAAA;EAAA,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,wBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;AACR;AAEI;;EAEI,wBAAA;AAAR;AAGI;EACI,cAAA;AADR;AAOI;EACI,YAAA;AALR;AAQI;EACI,cAAA;AANR;AASI;EACI,4CAAA;EACA,cAAA;AAPR;;AAWA;EACI,eAAA;AARJ;;AAWA;EACI,eAAA;AARJ;;AAWA;EACI,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AARJ;AAUI;EACI,qBAAA;EACA,eAAA;EACA,aAAA;AARR;;AAYA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AATJ;AAWI;EACI,eAAA;AATR","sourcesContent":[".hayah {\n    font-size: 150px;\n    display: block;\n    width: 100%;\n    margin-bottom: 30px;\n    margin-top: 3vh;\n    color: #ab8774;\n    text-align: center;\n    text-shadow: 1px 1px #dbb49f;\n}\n\nion-list {\n    --background: transparent;\n    background: transparent;\n}\n\nion-item {\n    border-radius: 4px;\n    border-bottom: 5px solid #d1a992;\n    margin-bottom: 5px;\n    padding-bottom: 2px;\n}\n\nion-label {\n    color: #ab8774 !important;\n}\n\nion-input,\nion-textarea,\ninput::-webkit-input-placeholder {\n    color: #dbb49f;\n}\n\nion-input,\nion-textarea,\ninput {\n    color: #866858;\n}\n\n.auth_start {\n    text-align: center;\n    margin-top: 5vh;\n\n    button {\n        min-width: 60%;\n        width: fit-content;\n        padding: 20px;\n        border: 1px solid #d2a892;\n        border-bottom-width: 4px;\n        background: none;\n        border-radius: 4px;\n        color: #a0755f;\n        margin-top: 0px;\n        margin-bottom: 10px;\n        font-size: 12px;\n        font-weight: bold;\n        white-space: nowrap;\n        text-transform: uppercase;\n    }\n\n    button:hover,\n    button:active {\n        border-bottom-width: 6px;\n    }\n\n    label {\n        color: #ab8774;\n    }\n\n    .signup_warn {\n    }\n\n    ion-list {\n        margin: 25px;\n    }\n\n    .form_floater {\n        color: #8e8e8e;\n    }\n\n    .filled {\n        background: #a0755fc6;\n        color: #fff1e5;\n    }\n}\n\n.start_auth {\n    margin-top: 0vh;\n}\n\n.forgot_pass_txt {\n    font-size: 12px;\n}\n\n.signup_txt {\n    text-align: center;\n    width: 80%;\n    margin-left: auto;\n    margin-right: auto;\n    color: #b6917c;\n\n    b {\n        display: inline-block;\n        font-size: 21px;\n        margin: 8px 0;\n    }\n}\n\n.inline_inputter {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n\n    ion-icon {\n        font-size: 21px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
